import styled from "styled-components";
import { MainInner } from "@/styles/global";
import { Paragraph, TextLinkCss, h3, h5 } from "@/styles/typography";

const Inner = styled(MainInner)``;

const Container = styled.div<{ $bgColor: string }>`
  background: ${({ $bgColor }) => `${$bgColor}`};
  gap: 32px;
  display: flex;
  flex-direction: column;
  padding: 24px;
  border-radius: 4px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex-direction: row;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding: 80px 40px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: 45%;
    gap: 16px;
  }
`;

const Title = styled(h3)<{ $bgColor: string }>`
  font-size: 26px;
  color: ${({ $bgColor, theme }) =>
    $bgColor === "purple" || $bgColor === "standard"
      ? theme.colors.coreLight
      : theme.colors.textHeading};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    font-size: clamp(26px, 3vw, 40px);
  }
`;

const Text = styled(Paragraph)<{ $bgColor: string }>`
  color: ${({ $bgColor, theme }) =>
    $bgColor === "purple" || $bgColor === "standard"
      ? theme.colors.coreLight
      : theme.colors.textBody};
`;

const ContactsWrapper = styled.div<{ $bgColor: string }>`
  h5,
  a,
  p {
    color: ${({ $bgColor, theme }) =>
      $bgColor === "purple" || $bgColor === "standard"
        ? theme.colors.coreLight
        : theme.colors.textBody};
  }
  a svg path {
    stroke: ${({ $bgColor, theme }) =>
      $bgColor === "purple" || $bgColor === "standard"
        ? theme.colors.coreLight
        : theme.colors.textBody};
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: 45%;
  }
`;

const Contact = styled.div<{ $bgColor: string }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 0;
  border-bottom: 1px solid
    ${({ $bgColor, theme }) =>
      $bgColor === "purple" || $bgColor === "standard"
        ? theme.colors.coreLight
        : theme.colors.textBody};

  &:last-of-type {
    border-bottom: none;
  }

  &:first-of-type {
    padding-top: 0;
  }
`;

const ContactTitle = styled(h5)`
  color: ${({ theme }) => theme.colors.coreLight};
`;

const ContactLink = styled.a<{ $bgColor: string }>`
  ${TextLinkCss}
  align-items: center;
  display: flex;
  gap: 8px;
  color: ${({ theme }) => theme.colors.coreLight};
  text-decoration: underline;
  text-decoration-color: transparent;
  transition: text-decoration-color 0.3s ease;

  svg {
    width: 20px;
    height: 20px;
    path {
      stroke: ${({ theme }) => theme.colors.coreLight};
    }
  }

  &:hover {
    text-decoration-color: ${({ $bgColor, theme }) =>
      $bgColor === "purple" || $bgColor === "standard"
        ? theme.colors.coreLight
        : theme.colors.textBody};
  }
`;

const ContactText = styled.p`
  ${TextLinkCss}
  color: ${({ theme }) => theme.colors.coreLight};
`;

const S = {
  Inner,
  Container,
  Title,
  TextWrapper,
  Text,
  ContactsWrapper,
  Contact,
  ContactTitle,
  ContactLink,
  ContactText,
};

export default S;
